import {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  MENU_ARGS,
  POSITIONING_ARGS,
} from './metadata/shared-arguments';

import { Arg, ArgTypes, Metadata, pick, pickAll } from './metadata/builder';

// Re-export all shared arguments
export {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  MENU_ARGS,
  POSITIONING_ARGS,
};

// Re-export Metadata builder classes and helpers
export { Arg, ArgTypes, Metadata, pick, pickAll };

export default {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  BUTTON_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  CONTENT_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  MENU_ARGS,
  POSITIONING_ARGS,
  Arg,
  ArgTypes,
  Metadata,
  pick,
  pickAll,
};
